import { gql } from '@apollo/client';

const UPDATE_API_HOOK_URL = gql`
    mutation UpdateApiHookUrl(
        $profileId: Int!
        $urlType: String!
        $url: String!
        $environment: String!
    ) {
        updateApiHookUrl(
            profileId: $profileId
            urlType: $urlType
            url: $url
            environment: $environment
        )
    }
`;

export default UPDATE_API_HOOK_URL;
